import styled from 'styled-components'
import { GRAYSCALE_600, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  flex: 1;
  overflow: auto;
  padding: 16px 12px;
  padding-bottom: 80px;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  margin-top: 32px;
`

export const DescriptionText = styled.span`
  font-family: ${INTER.light};
  color: ${GRAYSCALE_600};
`

export const LevelCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-bottom: 100px;
`

export const BottomButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  background-color: ${WHITE};
  display: flex;
  justify-content: flex-end;
  width: 100%;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.05);
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`
